<template>
  <v-container>
    <v-form ref="form" v-model="isFormValid" lazy-validation>
      <v-row>
        <v-col cols="12">
          <v-card class="px-7 mt-4 pt-7">
            <v-row>
              <v-col cols="12">
                <SimplePageHeader
                  v-if="!isEdit"
                  title="Add User"
                ></SimplePageHeader>
                <SimplePageHeader
                  v-else
                  title="Edit User"
                >
                  <template v-slot:right-buttons>
                    <v-switch
                      v-model="active"
                      label="Active"
                      class="float-end"
                    ></v-switch>
                  </template>
                </SimplePageHeader>
              </v-col>
            </v-row>
            <v-row class="pt-3">
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="firstName"
                  :rules="nameRules"
                  label="First Name"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="lastName"
                  :rules="nameRules"
                  label="Last Name"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <EmailInput
                  :label="'Login E-Mail'"
                  :email-address="emailAddress"
                  :is-required="true"
                  :disabled="false"
                  @emailChange="handleEmailAddressChange"
                ></EmailInput>
              </v-col>
            </v-row>
            <v-row class="pb-3">
              <v-col cols="12" sm="6">
                <SecurityRolesDropDownList
                  :securityRoles="securityRoles"
                  :multiple="true"
                  :isRequired="true"
                  @securityRolesChange="handleSecurityRolesChange"
                ></SecurityRolesDropDownList>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <ButtonsSubmitForm
        :isFormValid="isFormValid"
        @save="handleSaveUser"
        @cancel="cancel"
      >
      </ButtonsSubmitForm>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { usersRoute } from '@/lib/constants/routes'
import { SecurityRolesDropDownList } from '@/components/securityRoles'
import { ButtonsSubmitForm } from '@/components/buttons'
import { required } from '@/lib/formValidations'
import { SimplePageHeader } from '@/components/pageComponents'
import { EmailInput } from '@/components/emails'

export default {
  components: {
    SecurityRolesDropDownList,
    ButtonsSubmitForm,
    SimplePageHeader,
    EmailInput
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.previousRoute = from
    })
  },
  data: () => ({
    isFormValid: false,
    previousRoute: null,
    nameRules: [
      v => !!v || 'This field is required',
      v => (v && v.length <= 250) || 'This field must be less than 250 characters'
    ],
    addresses: [],
    commissions: [],
    showCommissionsTiersTable: false
  }),
  computed: {
    ...mapFields('user', [
      'firstName',
      'lastName',
      'fullName',
      'password',
      'emailAddress',
      'active',
      'securityRoles'
    ]),
    id: {
      get () {
        return this.$route.params.id || null
      }
    },
    isEdit: {
      get () {
        return !!this.id
      }
    }
  },
  methods: {
    required,
    ...mapActions('user', [
      'getUser',
      'saveUser',
      'clearUser'
    ]),
    loadUserData () {
      this.getUser({ id: this.id })
    },
    handleSecurityRolesChange (value) {
      this.securityRoles = value
    },
    handleSaveUser () {
      if (this.$refs.form.validate()) {
        this.saveUser()
          .then(() => {
            if (this.previousRoute && this.previousRoute.name === usersRoute.name) {
              this.$router.back()
              return
            }
            this.$router.push({ name: usersRoute.name })
          })
      }
    },
    cancel () {
      if (this.previousRoute && this.previousRoute.name === usersRoute.name) {
        this.$router.back()
        return
      }
      // Fallback to Vue Router navigation which resets the filters, sorting, and pagination
      this.$router.push({ name: usersRoute.name })
    },
    handleEmailAddressChange (value) {
      this.emailAddress = value
    }
  },
  mounted () {
    this.$refs.form.resetValidation()
    if (this.isEdit) {
      this.loadUserData()
    } else {
      this.clearUser()
      this.active = true
    }
  }
}
</script>
